import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { ExternalLink } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@osmix/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@osmix/ui/dialog";
export function AdminDetailModal(t0) {
  const $ = _c(17);
  const {
    open,
    title,
    fullPageHref,
    fullPageLabel: t1,
    children,
    onOpenChange
  } = t0;
  const fullPageLabel = t1 === undefined ? "Open full page" : t1;
  let t2;
  if ($[0] !== title) {
    t2 = <DialogTitle>{title}</DialogTitle>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fullPageHref || $[3] !== fullPageLabel) {
    t3 = fullPageHref && <Button variant="outline" size="sm" asChild={true}><Link to={fullPageHref}><ExternalLink className="size-4" />{fullPageLabel}</Link></Button>;
    $[2] = fullPageHref;
    $[3] = fullPageLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <DialogHeader className="pr-8"><div className="flex items-center justify-between gap-3">{t2}{t3}</div></DialogHeader>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== children) {
    t5 = <div className="min-w-0">{children}</div>;
    $[8] = children;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-5xl">{t4}{t5}</DialogContent>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onOpenChange || $[14] !== open || $[15] !== t6) {
    t7 = <Dialog open={open} onOpenChange={onOpenChange}>{t6}</Dialog>;
    $[13] = onOpenChange;
    $[14] = open;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}